import React from "react";
import {Alert} from "peggirkit";
import useProductInfo from "@widgets/pos/order/menu/product/context/ProductInfoProvider";
import {FormattedMessage} from "react-intl";


const ProductAlcoholWarning = () => {
    const {isAlcoholic} = useProductInfo();

    if (!isAlcoholic) {
        return <></>;
    }

    return (
        <Alert
            type={"warning"}
            title={<FormattedMessage id={"alcoholCheck"}/>}
            content={<FormattedMessage id={"alcoholCheckInfo"}/>}
        />
    );
};

export default ProductAlcoholWarning;